import type { WellKnownPropertyValues, GlobalLoggingContextProvider } from "@octopusdeploy/logging";
import type { PageDefinition } from "@octopusdeploy/portal-routes";
type PortalGlobalLoggingContext = WellKnownPropertyValues<{
    pageid?: string;
    BrowserSessionId?: string;
}>;
let portalLoggerContext: PortalGlobalLoggingContext = {};
export const portalLoggingContextProvider: GlobalLoggingContextProvider<PortalGlobalLoggingContext> = {
    getProperties: () => ({ ...portalLoggerContext }),
    reset: () => globalPortalLogContext.resetContext(),
};
export const globalPortalLogContext = {
    resetContext() {
        portalLoggerContext = {};
    },
    setPage(page: PageDefinition) {
        portalLoggerContext.pageid = page.Id;
    },
    setBrowserSessionId(browserSessionId: string) {
        portalLoggerContext.BrowserSessionId = browserSessionId;
    },
};
